import { onError } from 'apollo-link-error';
import { Auth } from 'aws-amplify';

import { messages } from 'app-constants';
import { captureException } from '../../../services/sentry';

export default function getErrorLink(showSnackbar) {
  return onError((error) => {
    let isUnAuthorized = false;
    const { graphQLErrors, networkError } = error || {};
    if (graphQLErrors) {
      const isUnAuthorizedTypes = [
        'Lambda:EC2AccessDeniedException',
        'UnauthorizedException'
      ];
      isUnAuthorized = graphQLErrors.some(({ errorType }) => {
        return isUnAuthorizedTypes.includes(errorType);
      });

      graphQLErrors.forEach((e) => {
        e.message = `Graphql Error: ${e.message}`;
        captureException(e);
      });
    }

    if (networkError) {
      networkError.message = `Graphql NetworkError: ${networkError.message}`;
      captureException(networkError);
    }

    if (!isUnAuthorized && networkError) {
      if (networkError.statusCode === 401) {
        isUnAuthorized = true;
      }
    }

    if (isUnAuthorized) {
      showSnackbar({
        message: messages.UNAUTHORIZED_SIGNOUT,
        options: { variant: 'error' }
      });
      Auth.signOut({ global: true });
      return;
    }

    showSnackbar({
      message: error,
      options: { variant: 'error' }
    });
  });
}
